export const Bell = ({ className }) =>
(
    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={`${className}`}>
        <path d="M6 15V16C6 16.7956 6.31607 17.5587 6.87868 18.1213C7.44129 18.6839 8.20435 19 9 19C9.79565 19 10.5587 18.6839 11.1213 18.1213C11.6839 17.5587 12 16.7956 12 16V15M7 3C7 2.46957 7.21071 1.96086 7.58579 1.58579C7.96086 1.21071 8.46957 1 9 1C9.53043 1 10.0391 1.21071 10.4142 1.58579C10.7893 1.96086 11 2.46957 11 3C12.1484 3.54303 13.1274 4.38833 13.8321 5.4453C14.5367 6.50227 14.9404 7.73107 15 9V12C15.0753 12.6217 15.2954 13.2171 15.6428 13.7381C15.9902 14.2592 16.4551 14.6914 17 15H1C1.54494 14.6914 2.00981 14.2592 2.35719 13.7381C2.70457 13.2171 2.92474 12.6217 3 12V9C3.05956 7.73107 3.4633 6.50227 4.16795 5.4453C4.8726 4.38833 5.85159 3.54303 7 3Z" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
);



export const HomeIcon = ({ className }) =>
(
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" className={`${className}`}>
        <path d="M3.16667 9H1.5L9 1.5L16.5 9H14.8333M3.16667 9V14.8333C3.16667 15.2754 3.34226 15.6993 3.65482 16.0118C3.96738 16.3244 4.39131 16.5 4.83333 16.5H13.1667C13.6087 16.5 14.0326 16.3244 14.3452 16.0118C14.6577 15.6993 14.8333 15.2754 14.8333 14.8333V9" stroke="#1F2937" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M6.5 16.5V11.5C6.5 11.058 6.6756 10.6341 6.98816 10.3215C7.30072 10.009 7.72464 9.83337 8.16667 9.83337H9.83333C10.2754 9.83337 10.6993 10.009 11.0118 10.3215C11.3244 10.6341 11.5 11.058 11.5 11.5V16.5" stroke="#1F2937" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
);

export const FuelIcon = ({ className }) => (
    <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className}`}
    >
        <path
            d="M4 14V6C4 5.44772 4.44772 5 5 5H9C9.55228 5 10 5.44772 10 6V14M4 14H10M4 14H2.5V3C2.5 2.44772 2.94772 2 3.5 2H6.5C7.05228 2 7.5 2.44772 7.5 3V4M10 14H11.5V7C11.5 6.44772 11.9477 6 12.5 6H13.5C14.0523 6 14.5 6.44772 14.5 7V14H13M7.5 4H10"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const TiresIcon = ({ className }) => (
    <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className}`}
    >
        <path
            d="M9 15C12.3137 15 15 12.3137 15 9C15 5.68629 12.3137 3 9 3C5.68629 3 3 5.68629 3 9C3 12.3137 5.68629 15 9 15Z"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9 11.5C10.3807 11.5 11.5 10.3807 11.5 9C11.5 7.61929 10.3807 6.5 9 6.5C7.61929 6.5 6.5 7.61929 6.5 9C6.5 10.3807 7.61929 11.5 9 11.5Z"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7.5 9H10.5M9 7.5V10.5"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const ServicesIcon = ({ className }) => (
    <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className}`}
    >
        <path
            d="M6.5 11.5L4 14L7 17L9.5 14.5M6.5 11.5L9 9M6.5 11.5L4 9M11.5 6.5L14 4L11 1L8.5 3.5M11.5 6.5L9 9M11.5 6.5L14 9"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const VehiclesIcon = ({ className }) => (
    <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className}`}
    >
        <path
            d="M3 12H15C15.5523 12 16 11.5523 16 11V7C16 6.44772 15.5523 6 15 6H3C2.44772 6 2 6.44772 2 7V11C2 11.5523 2.44772 12 3 12Z"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.5 14C5.32843 14 6 13.3284 6 12.5C6 11.6716 5.32843 11 4.5 11C3.67157 11 3 11.6716 3 12.5C3 13.3284 3.67157 14 4.5 14Z"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13.5 14C14.3284 14 15 13.3284 15 12.5C15 11.6716 14.3284 11 13.5 11C12.6716 11 12 11.6716 12 12.5C12 13.3284 12.6716 14 13.5 14Z"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6 9H12"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);


export const IncidentsIcon = ({ className }) => (
    <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className}`}
    >
        <path
            d="M9 2L2 9H7V13L12 11V7H9L15 2H9Z"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9 2V13"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const RenewalsIcon = ({ className }) => (
    <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className}`}
    >
        <path
            d="M15 9C15 12.3137 12.3137 15 9 15C5.68629 15 3 12.3137 3 9C3 5.68629 5.68629 3 9 3"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12 3H15V6"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9 9L10.5 7.5L12 9"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const ExpensesIcon = ({ className }) => (
    <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className}`}
    >
        <path
            d="M3 5H15V13C15 13.5523 14.5523 14 14 14H4C3.44772 14 3 13.5523 3 13V5Z"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6 5V4C6 3.44772 6.44772 3 7 3H11C11.5523 3 12 3.44772 12 4V5"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9 8V11"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7.5 9.5H10.5"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const MeterIcon = ({ className }) => (
    <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className}`}
    >
        <path
            d="M9 15C12.3137 15 15 12.3137 15 9C15 5.68629 12.3137 3 9 3C5.68629 3 3 5.68629 3 9"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9 9L12 6"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6 12H12"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const RemindersIcon = ({ className }) => (
    <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className}`}
    >
        <path
            d="M5 3H13C14.1046 3 15 3.89543 15 5V13C15 14.1046 14.1046 15 13 15H5C3.89543 15 3 14.1046 3 13V5C3 3.89543 3.89543 3 5 3Z"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3 6H15"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7 9H8"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7 12H8"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const ReportsIcon = ({ className }) => (
    <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className}`}
    >
        <path
            d="M3 15V7C3 6.44772 3.44772 6 4 6H6C6.55228 6 7 6.44772 7 7V15"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8 15V4C8 3.44772 8.44772 3 9 3H11C11.5523 3 12 3.44772 12 4V15"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13 15V10C13 9.44772 13.4477 9 14 9H16C16.5523 9 17 9.44772 17 10V15"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const OffersIcon = ({ className }) => (
    <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className}`}
    >
        <path
            d="M3 5H15V13C15 13.5523 14.5523 14 14 14H4C3.44772 14 3 13.5523 3 13V5Z"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6 8L12 11"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12 8L6 11"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6 8H6.01"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12 11H12.01"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const VendorsIcon = ({ className }) => (
    <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className}`}
    >
        <path
            d="M3 15V7C3 6.44772 3.44772 6 4 6H7C7.55228 6 8 6.44772 8 7V15"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10 15V4C10 3.44772 10.4477 3 11 3H14C14.5523 3 15 3.44772 15 4V15"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7 9H10"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const SettingsIcon = ({ className }) => (
    <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className}`}
    >
        <path
            d="M9 11.5C10.3807 11.5 11.5 10.3807 11.5 9C11.5 7.61929 10.3807 6.5 9 6.5C7.61929 6.5 6.5 7.61929 6.5 9C6.5 10.3807 7.61929 11.5 9 11.5Z"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.5 9C14.5 9.55228 14.0523 10 13.5 10H13.25C12.6977 10 12.25 9.55228 12.25 9C12.25 8.44772 12.6977 8 13.25 8H13.5C14.0523 8 14.5 8.44772 14.5 9Z"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M5.75 9C5.75 9.55228 5.30228 10 4.75 10H4.5C3.94772 10 3.5 9.55228 3.5 9C3.5 8.44772 3.94772 8 4.5 8H4.75C5.30228 8 5.75 8.44772 5.75 9Z"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9 5.75C9.55228 5.75 10 5.30228 10 4.75V4.5C10 3.94772 9.55228 3.5 9 3.5C8.44772 3.5 8 3.94772 8 4.5V4.75C8 5.30228 8.44772 5.75 9 5.75Z"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9 14.5C9.55228 14.5 10 14.0523 10 13.5V13.25C10 12.6977 9.55228 12.25 9 12.25C8.44772 12.25 8 12.6977 8 13.25V13.5C8 14.0523 8.44772 14.5 9 14.5Z"
            stroke="#1F2937"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);



export const CollapseIcon = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" id="Layout-Sidebar-Right-Collapse--Streamline-Tabler" height="24" width="24"
        className={`${className}`}
    >
        <desc>
        </desc>
        <path d="M4 6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2H6a2 2 0 0 1 -2 -2z" stroke-width="2"></path>
        <path d="M15 4v16" stroke-width="2"></path>
        <path d="m9 10 2 2 -2 2" stroke-width="2"></path>
    </svg>
);


export const locationIconSvg = `
<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
    <circle cx="9" cy="9" r="9" fill="#1D4F91" />
    <path d="M9 4.5C7.067 4.5 5.5 6.067 5.5 8C5.5 10.75 9 14.5 9 14.5C9 14.5 12.5 10.75 12.5 8C12.5 6.067 10.933 4.5 9 4.5Z" fill="white"/>
    <circle cx="9" cy="8" r="1.5" fill="#1D4F91" />
</svg>
`;
